import { render, staticRenderFns } from "./ShopAutoComplete.vue?vue&type=template&id=2f813e2e&scoped=true&"
import script from "./ShopAutoComplete.vue?vue&type=script&lang=js&"
export * from "./ShopAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f813e2e",
  null
  
)

export default component.exports